import { ACTIVITY_ACTION_TYPES } from 'store/actions/activity.actions';

const initialState = {
  data: {},
  processing: {
    processing: true,
    processingActivityNew: true,
  },
  activityData: {},
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case ACTIVITY_ACTION_TYPES.ACTIVITY_SET_DATA_BY_KEY:
      return {
        ...state,
        [payload.stateKeyForDataSaving]: payload.data,
      };
    case ACTIVITY_ACTION_TYPES.ACTIVITY_CHANGE_PROCESSING:
      return {
        ...state,
        processing: {
          ...state.processing,
          [payload.processingDestination]: payload.newState,
        },
      };
    case ACTIVITY_ACTION_TYPES.ACTIVITY_NEW_CHANGE_PROCESSING:
      return {
        ...state,
        processingActivityNew: payload,
      };
    case ACTIVITY_ACTION_TYPES.ACTIVITY_CLEAR_STATE:
      return { ...state, [payload.clearedKey]: {} };
    default:
      return state;
  }
}
